import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { installErrorReporter } from "./lib/error-reporter";
import { router } from "./router";
import "./index.css";
// Dev-only, iframe-only: lets NymblStudio's Build → App "Inspect" picker reach
// this app's DOM (Nymbl App Spec §2.9). Compiled out of production builds, and
// imported purely for its side effect — without this line it is tree-shaken
// away and the inspector reports itself unavailable.
import "@/lib/studio-inspector";

// Before the first render, so an error thrown on the way up is still captured.
installErrorReporter();

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
